import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const partnerStaticData = {
  menuTitle: MenuTitle.Partner
};
export const Route = createFileRoute('/_private-routes/partner')({
  staticData: partnerStaticData
});
